import { MentionableTask } from '../../../../../../clients/sidebar/views/CreateTask/create_task/types';
import { DashboardTask } from './queries';

type ReferencedTask = {
  id: string;
  localTaskId: string;
  display: string;
  priorityId: string | null;
};

export const mapMentionableTasks = (
  referencedTasks: ReferencedTask[],
  task: DashboardTask,
  bugherdUrl: string
): MentionableTask[] =>
  referencedTasks.map(({ id, localTaskId, display, priorityId }) => ({
    id: Number(id),
    localTaskId: Number(localTaskId),
    display,
    severity: priorityId ? Number(priorityId) : 0,
    requester: 0,
    columnId: Number(task.columnId || 0),
    column: task.column as MentionableTask['column'],
    statusId: task.statusId ? Number(task.statusId) : null,
    viewURL: `${bugherdUrl}/projects/${task.project.id}/tasks/${localTaskId}`
  }));
